
if(!customElements.get('blog-pagination-button')){
    class BlogPostsPaginationButton extends HTMLElement {
        constructor(){
            super();
            this.init();
        }

        init(){
            this.btnLoadMore = this.querySelector('.btn-load-more');

            if(this.closest('custom-blog-posts')){
                this.postsList = this.closest('custom-blog-posts');
                this.postsWrapper = this.postsList.querySelector('#blog-posts__list-wrapper');
                this.posts = this.postsWrapper.querySelector('.blog-posts__list');

            }

            this.btnColumnSwitch = this.postsList.querySelector('.view-switch-wrapper');

            this.btnLoadMore.addEventListener('click', e => {
                e.preventDefault();

                this.btnLoadMore.setAttribute('data-disabled', 'true');

                this.loadMorePosts();
            })
        }

        async loadMorePosts(){
            try{
                const nextPageRes = await fetch(
                    `${this.btnLoadMore.dataset.url}`
                );
                const nextPageText = await nextPageRes.text();
                const nextPageHTML = new DOMParser().parseFromString(nextPageText, 'text/html');

                const postsWrapper = nextPageHTML.querySelector('#blog-posts__list-wrapper');
                const posts = postsWrapper.querySelector('.blog-posts__list');
                const btnLoadMore = postsWrapper.querySelector('.btn-load-more');

                // get blog posts
                const articleCards = posts.querySelectorAll(".blog-post-card__wrapper");

                articleCards.forEach(item => {
                    if(this.btnColumnSwitch.dataset.column == '3'){
                        item.classList.add('col-md-3');
                        item.classList.add('col-6');
                        item.classList.remove('col-md-4');
                        item.classList.remove('col-12');
                    }else{
                        item.classList.add('col-md-4');
                        item.classList.add('col-12');
                        item.classList.remove('col-md-3');
                        item.classList.remove('col-6');
                    }

                    this.posts.appendChild(item);
                })

                if(btnLoadMore){
                    this.btnLoadMore.classList.remove('d-none');
                    this.btnLoadMore.setAttribute('data-url', `${btnLoadMore.dataset.url}`);
                }else{
                    this.btnLoadMore.classList.add('d-none');
                }

            }catch(error){

                console.error(error);
                alert(error.message);

            } finally{
                this.btnLoadMore.setAttributeNS('data-disabled', 'false');
            }
        }
    }

    customElements.define('blog-pagination-button', BlogPostsPaginationButton);
}